// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image-text[data-v-8cc668b8] {\n  vertical-align: middle;\n}\n.p-treetable .p-treetable-tbody > tr > td[data-v-8cc668b8] {\n  padding: 0.2rem 0.2rem !important;\n}", ""]);
// Exports
module.exports = exports;
